import { Color, Icon } from '@billy/design-system'
import { ReactElement } from 'react'

import { useLogo } from '../../../../hooks/useLogo'
import { NavigationVariant } from '../../types/navigationVariant'
import { AvatarImage } from '../AvatarImage'
import * as Styled from './styles'

const iconColorByVariant: Record<NavigationVariant, Color> = {
  default: Color.Green300,
  inverted: Color.Green950,
}

interface OrganizationAvatarProps {
  logoId?: string
  variant?: NavigationVariant
}

export const UmbrellaAvatar = ({ logoId, variant = 'default' }: OrganizationAvatarProps): ReactElement => {
  const { url } = useLogo(logoId)

  return (
    <Styled.UmbrellaAvatarWrapper variant={variant}>
      {url ? <AvatarImage src={url} alt="Avatar" /> : <Icon icon="network" color={iconColorByVariant[variant]} />}
    </Styled.UmbrellaAvatarWrapper>
  )
}
